// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedCard {
  border-radius: 15px;
}

.voteTitleContainer {
  margin-top: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.voteTitleTextContainer{
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.editVoteContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #070F0F;
  border-radius: 10px;
  border: 1px solid #5AAF9A;
  cursor: pointer;
}

.voteTitleText {
  color: #fff;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.4;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
}

.selectedOptionText {
  color: #A0B3B0;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  /* Add text wrapping properties */
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
}

/* Options percentage and text styling matching Ballots page */
.vote-percentage {
  position: relative;
  z-index: 2;
  font-size: 14px;
  font-weight: 600;
  color: white;
}

.vote-text.voted,
.vote-percentage.voted {
  color: #777777;
}

.vote-button-wrapper.selected .vote-text,
.vote-button-wrapper.selected .vote-percentage {
  color: #ffffff !important;
  font-weight: 700;
}

.noVotesMessageText {
  color: #666;
  margin-bottom: 8px;
  font-size: 24px;
  font-family: "Inter", sans-serif;
}

.noVotesMessageText2 {
  color: #999;
  text-align: center;
  font-size: 16px;
  max-width: 400px;
  font-family: "Inter", sans-serif;
}

@media (max-width: 1640px) {
  .voteTitleText {
    font-size: 16px;
  }
  .selectedOptionText {
    font-size: 14px;
  }
  .editVoteContainer {
    width: 35px;
    height: 35px;
    border-radius: 10px;
  }
}
@media (max-width: 1440px) {
  .voteTitleText {
    font-size: 15px;
  }
  .selectedOptionText {
    font-size: 13px;
  }
  .editVoteContainer {
    width: 30px;
    height: 30px;
    border-radius: 10px;
  }
}
@media (max-width: 1280px) {
  .voteTitleText {
    font-size: 14px;
  }
  .selectedOptionText {
    font-size: 12px;
  }
  .editVoteContainer {
    width: 25px;
    height: 25px;
    border-radius: 8px;
  }
}
@media (max-width: 1024px) {
  .voteTitleText {
    font-size: 13px;
  }
  .selectedOptionText {
    font-size: 10px;
  }
  .editVoteContainer {  
    width: 20px;
    height: 20px;
    border-radius: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/VoteHistory/VoteHistory.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF","sourcesContent":[".feedCard {\n  border-radius: 15px;\n}\n\n.voteTitleContainer {\n  margin-top: 0px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.voteTitleTextContainer{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.editVoteContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background-color: #070F0F;\n  border-radius: 10px;\n  border: 1px solid #5AAF9A;\n  cursor: pointer;\n}\n\n.voteTitleText {\n  color: #fff;\n  font-family: \"Inter\", sans-serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1.4;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n\n.selectedOptionText {\n  color: #A0B3B0;\n  font-family: \"Inter\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  /* Add text wrapping properties */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n\n/* Options percentage and text styling matching Ballots page */\n.vote-percentage {\n  position: relative;\n  z-index: 2;\n  font-size: 14px;\n  font-weight: 600;\n  color: white;\n}\n\n.vote-text.voted,\n.vote-percentage.voted {\n  color: #777777;\n}\n\n.vote-button-wrapper.selected .vote-text,\n.vote-button-wrapper.selected .vote-percentage {\n  color: #ffffff !important;\n  font-weight: 700;\n}\n\n.noVotesMessageText {\n  color: #666;\n  margin-bottom: 8px;\n  font-size: 24px;\n  font-family: \"Inter\", sans-serif;\n}\n\n.noVotesMessageText2 {\n  color: #999;\n  text-align: center;\n  font-size: 16px;\n  max-width: 400px;\n  font-family: \"Inter\", sans-serif;\n}\n\n@media (max-width: 1640px) {\n  .voteTitleText {\n    font-size: 16px;\n  }\n  .selectedOptionText {\n    font-size: 14px;\n  }\n  .editVoteContainer {\n    width: 35px;\n    height: 35px;\n    border-radius: 10px;\n  }\n}\n@media (max-width: 1440px) {\n  .voteTitleText {\n    font-size: 15px;\n  }\n  .selectedOptionText {\n    font-size: 13px;\n  }\n  .editVoteContainer {\n    width: 30px;\n    height: 30px;\n    border-radius: 10px;\n  }\n}\n@media (max-width: 1280px) {\n  .voteTitleText {\n    font-size: 14px;\n  }\n  .selectedOptionText {\n    font-size: 12px;\n  }\n  .editVoteContainer {\n    width: 25px;\n    height: 25px;\n    border-radius: 8px;\n  }\n}\n@media (max-width: 1024px) {\n  .voteTitleText {\n    font-size: 13px;\n  }\n  .selectedOptionText {\n    font-size: 10px;\n  }\n  .editVoteContainer {  \n    width: 20px;\n    height: 20px;\n    border-radius: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
